module.exports = __webpack_public_path__ + "static/media/new-wb-franja-app-english.bc9c006f.svg";